import { Vec2 } from "utils/math/vec2";
import { Mat3 } from "utils/math/mat3";
import { Webgl2dRenderer } from "../webgl2d-renderer";
import { Webgl2Tool } from "./webgl2-tool";

export class HandTool extends Webgl2Tool {
  private _startCamTransform = Vec2.zero();
  private _startMove = Vec2.zero();
  private _startInvViewProjMat = Mat3.identity();

  private get _camera() {
    return this._renderer.camera;
  }

  constructor(private readonly _renderer: Webgl2dRenderer) {
    super();
  }

  public onMouseDown(e: MouseEvent) {
    this.handleDown(e);
  }

  public onMouseMove(e: MouseEvent) {
    this.handleMove(e);
  }

  public onTouchStart(e: TouchEvent) {
    this.handleDown(e);
  }

  public onTouchMove(e: TouchEvent) {
    this.handleMove(e);
  }

  public handleDown(e: MouseEvent | TouchEvent) {
    this._startInvViewProjMat = this._camera.viewProjection.invert();
    const clipSpace = this._camera.getClipSpacePosition(this._camera.getCSSMousePosition(e));
    this._startMove.copy(clipSpace.transformMat3Det(this._startInvViewProjMat.mat));
    this._startCamTransform.copy(this._camera.translation);
  }

  public handleMove(e: MouseEvent | TouchEvent) {
    const clipSpace = this._camera.getClipSpacePosition(this._camera.getCSSMousePosition(e));
    const pos = clipSpace.transformMat3Det(this._startInvViewProjMat.mat);

    const diff = this._startMove.clone().sub(pos);

    const newTransform = this._startCamTransform.clone().add(diff);

    this._camera.setTranslation(newTransform);
  }
}

export default HandTool;
